import { render } from "./DemandeDevisSinglePage.vue?vue&type=template&id=66206fc0&scoped=true&ts=true"
import script from "./DemandeDevisSinglePage.vue?vue&type=script&lang=ts"
export * from "./DemandeDevisSinglePage.vue?vue&type=script&lang=ts"

import "./DemandeDevisSinglePage.vue?vue&type=style&index=0&id=66206fc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66206fc0"]])

export default __exports__